module.exports = __webpack_public_path__ + "media/images/home/ic_edit-6f3895e32ee0266f73e9c594991fe9b1.svg";